import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createSquareNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

function createConsoleServerIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    <path d="M18 8L 34 20L18 32Z M18 8" fill="${ICON_DEFAULT_FOREGROUND_COLOR}"/>
    <rect x="6" y="8" width="9" height="2" fill="${ICON_DEFAULT_FOREGROUND_COLOR}"/>
    <rect x="6" y="19" width="9" height="2" fill="${ICON_DEFAULT_FOREGROUND_COLOR}"/>
    <rect x="6" y="30" width="9" height="2" fill="${ICON_DEFAULT_FOREGROUND_COLOR}"/>
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const consoleServerIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createConsoleServerIcon,
);
